const DraggableElement = (draggable, elementToMove) => {
    let startX = 0;
    let startY = 0;
    let currentX = 0;
    let currentY = 0;
    let offsetX = 0;
    let offsetY = 0;

    elementToMove.style.position = "absolute";
    draggable.style.cursor = "pointer";

    const dragStart = (e) => {
        e.preventDefault();
        const style = getComputedStyle(elementToMove);
        const matrix = new DOMMatrixReadOnly(style.transform);
        // Extract current translation values
        currentX = matrix.m41;
        currentY = matrix.m42;
        // Set initial mouse position
        startX = e.clientX;
        startY = e.clientY;
        document.onmouseup = dragEnd;
        document.onmousemove = drag;
    }

    const drag = (e) => {
        e.preventDefault();
        if (e.clientX === 0 && e.clientY === 0) return; // Ignore invalid events
        // Calculate drag offsets
        offsetX = e.clientX - startX;
        offsetY = e.clientY - startY;
        // Update transform with new translation values
        elementToMove.style.transform = `translate(${currentX + offsetX}px, ${currentY + offsetY}px)`;
    }

    const dragEnd = (e) => {
        e.preventDefault();
        // Update current translation values
        currentX += offsetX;
        currentY += offsetY;
        document.onmouseup = null;
        document.onmousemove = null;
    }
    draggable.addEventListener('mousedown', dragStart);
}

export { DraggableElement };